import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ThreadsModule = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Threads: User Level, Kernel Level Threads and Thread Models"
    videos={[
      "https://www.youtube.com/embed/x1tg2YUCs-c",
      "https://www.youtube.com/embed/kCazbHuf-70"
    ]}
    takeaways={[]}
    questions={[
      "What are the differences between user-level threads and kernel-level threads? Mention the advantages of using multithreaded programming in multicore architecture systems. Evaluate the scenario in which one type of thread is more advantageous than the other. Also illustrate the different multi-threading models. Discuss the threading issues in implementing it in multi-programming.",
      "What is multithreading? Mention the advantages of multi-threaded process over a single-threaded process. How is multi-threading related to concurrency and parallelism? Also, illustrate the different multi-threading models."
    ]}
    exampleVideos={[]}
  />
);
}

export default ThreadsModule;
